import React, { useContext, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import '../css/ModalAlert.css';
import { NewContext } from '../utils/ContextProvider';

const AUTO_CLOSE_MS = 2500;
const AUTO_CLOSE_ERROR_MS = 6000;
const STEP_MS = 25;

const GlobalAlert = () => {
  const { valuesAlert, setValuesAlert, setFlagAlert } = useContext(NewContext);
  const [getTipe, setTipe] = useState(valuesAlert.tipe || '');
  const [width, setWidth] = useState(100);

  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  const tipe = (getTipe === 'succes' || getTipe === 'warning' || getTipe === 'error')
    ? getTipe
    : 'warning';

  useEffect(() => {
    if (!valuesAlert?.tipe || !valuesAlert?.msj) return;

    setTipe(valuesAlert.tipe);
    setWidth(100);

    clearTimeout(timeoutRef.current);
    clearInterval(intervalRef.current);

    const duration = valuesAlert.tipe === 'error' ? AUTO_CLOSE_ERROR_MS : AUTO_CLOSE_MS;

    timeoutRef.current = setTimeout(() => {
      setValuesAlert({ msj: '', tipe: '' });
      setFlagAlert(false);
    }, duration);

    intervalRef.current = setInterval(() => {
      setWidth(prev => {
        const next = prev - (100 * STEP_MS / duration);
        return next <= 0 ? 0 : next;
      });
    }, STEP_MS);

    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(intervalRef.current);
    };
  }, [valuesAlert?.tipe, valuesAlert?.msj, setValuesAlert, setFlagAlert]);

  if (!valuesAlert?.tipe || !valuesAlert?.msj) return null;

  const node = (
    <div
      className={`contenedor-modal-alert ${tipe} show`}
      role="alert"
      aria-live="assertive"
    >
      <div className="contenedor-modal">
        <h4>
          {tipe === 'succes' ? 'Confirmado' : tipe === 'error' ? 'Error' : 'Advertencia'}
        </h4>
        <p>{valuesAlert.msj}</p>
      </div>
      <div
        className={
          tipe === 'succes'
            ? 'bar-succes'
            : tipe === 'warning'
              ? 'bar-worning'
              : 'bar-error'
        }
        style={{ width: `${width}%` }}
      />
    </div>
  );

  return createPortal(node, document.body);
};

export default GlobalAlert;
